export default __webpack_public_path__ + "static/realWorldImg4-b19d57accef43e4933a57db9c3e75a47.webp";